export enum Deployment {
    Dev = 'dev-seller',
    Local = 'local',
    Prod = 'seller',
    QA = 'qa-seller',
    Stage = 'stage-seller',
}
